import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import BillOfLadingDetail from 'src/features/BillOfLadingDetail';

const BillOfLadingDetailPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Bill Of Lading Detail</title>
      </Helmet>
      <BillOfLadingDetail />
    </MainLayout>
  );
};

export default BillOfLadingDetailPage;
